/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import React from 'react';

import { NoHeaderStreamBankMutableList } from "./NoHeaderStreamBankMutableList";
import { HelpIcon } from "../HelpIcon";
import { ConfirmationStatusViewer} from "../../../Models/Core/ServiceDrivenViewers";
import {useSortedData} from "../../../Hooks/ListHooks";

export const ConservationActionConfirmationStatusList = (props) => {
    const renderChildren = () => {
        const { RootData, Data, sortKey } = props;
        const data = useSortedData(Data, sortKey);

        let labelText = null;
        let valueCell = null;

        if (RootData?.conservationActionId == null) {
            labelText = <div className="text-center">Please save before specifying Confirmation Statuses.</div>;
        } else if (!data || data.length < 1) {
            labelText = (
                <div className="text-center">
                    No Confirmation Agencies have been designated for this Program.
                    <HelpIcon id={"help-icon-overall-confirmation-status"}>
                        Confirmation Agencies can be designated on the Program or Sub-Program Summary Edit Page.
                    </HelpIcon>
                </div>
            );
        } else {
            // get the lowest confirmationStatusId
            let confirmationStatusId = data.reduce((accumulator, currentValue) => {
                return (accumulator === null || currentValue.confirmationStatusId < accumulator) ? currentValue.confirmationStatusId : accumulator;
            }, null);
            
            labelText = (
                <div>Overall Confirmation Status
                    <HelpIcon id={"help-icon-overall-confirmation-status"}>
                        A conservation action is considered “Confirmed” and will appear in the Tracking Tool’s Confirmed Chart only when all of its Confirmation Statuses are set to “Confirmed”.
                    </HelpIcon>
                </div>
            );
            
            valueCell = (
                <td className={"sb-model-viewer-column sb-model-viewer-column-value"} colSpan="1">
                    <ConfirmationStatusViewer Value={confirmationStatusId} />
                </td>
            );
        }
        
        return (
            <div className="sb-mutable-list-item-section col-xs-12">
                <table className="sb-model-viewer editing table table-striped table-sm">
                    <tbody>
                    <tr className="sb-editor-row-confirmationAgencyId">
                        <td className="sb-model-viewer-column sb-model-viewer-column-label">
                            <label className="control-label">{labelText}</label>
                        </td>
                        {valueCell}
                    </tr>
                    <tr className="separator">
                        <td><hr /></td>
                        <td></td>
                    </tr>
                    </tbody>
                </table>
            </div>
        );
    };
    
    const children = renderChildren();
    
    return (
        <div>
            <NoHeaderStreamBankMutableList {...props}>
                {children}
            </NoHeaderStreamBankMutableList>
        </div>
    );
};
